module.exports = __webpack_public_path__ + "img/iconbusiness.96089ab5.png";